// extracted by mini-css-extract-plugin
export default {"wrapper":"RoundIdItem_wrapper__QB3lc","info":"RoundIdItem_info__7GWzX"};